import AccordionReducer from "../reducers/AccordionReducer";
import BaseAction from "./BaseAction";

class AccordionAction extends BaseAction {}

const action = new AccordionAction(AccordionReducer);

export default action;
